import React, { useState, useEffect } from 'react';
import { Container } from '@/components/ui/container';
import { Stack } from '@/components/ui/layout';
import { Heading, Text } from '@/components/ui/typography';
import { cn } from '@/lib/utils';

function Hero() {
  const [companyName, setCompanyName] = useState('');

  useEffect(() => {
    fetch('/api/get-company-name')
      .then(response => response.json())
      .then(data => {
        if (data.company_name) {
          setCompanyName(data.company_name);
        } else {
          console.error('Error fetching company name:', data.error);
        }
      })
      .catch(error => console.error('Error:', error));
  }, []);

  return (
    <section
      className={cn(
        "relative min-h-[40vh] flex items-center justify-center text-center",
        "bg-cover bg-center bg-no-repeat py-24"
      )}
      style={{
        backgroundImage: "url('https://cdn.builder.io/api/v1/image/assets/TEMP/70d4a9e6962ba0be1a978748ff16f4768ac3621f59809aed309f8041c5ca8d8c?placeholderIfAbsent=true&apiKey=7b6c1215e2f745adac7c4e4629a4a214')"
      }}
    >
      <div className="absolute inset-0 bg-primary/60 z-[1]" />
      <Container>
        <Stack spacing="md" align="center" className="relative z-[2] max-w-3xl mx-auto">
          <Heading level="h1" className="text-3xl md:text-4xl lg:text-5xl font-bold text-white drop-shadow-lg">
            Welcome, {companyName || 'NewZenAlpha'}
          </Heading>
          <Text size="lg" className="text-white/90 max-w-2xl">
            Your journey towards smarter and more efficient hiring begins here. Let's redefine the future together!
          </Text>
        </Stack>
      </Container>
    </section>
  );
}

export default Hero;